import { IconNoteOnPaper } from '../../../../assets/DesignSystem/SVGComponents';
import './CheckOrAddCommentsButton.scss';

const CheckOrAddCommentsButton = ({ openModal }: { openModal: () => void }) => {
  return (
    <div className="checkOrAddCommentsButton" onClick={openModal}>
      <IconNoteOnPaper className="iconNoteOnPaper" />
    </div>
  );
};

export default CheckOrAddCommentsButton;
